import React from 'react';
import './NavigationBar.css';

function NavigationBar({ user, onLogin, onLogout }) {
  return (
    <nav className="navbar">
      <div className="navbar-logo">📦</div>
      <div className="navbar-title">StorageBokks</div>
      <div className="navbar-profile">
        {user ? (
          <>
            <span className="navbar-user">{user.username}</span>
            <img className="navbar-avatar" src={`https://ui-avatars.com/api/?name=${encodeURIComponent(user.username)}`} alt="User Avatar" />
            <button onClick={onLogout} className="btn btn-secondary btn-sm">Logout</button>
          </>
        ) : (
          <button onClick={onLogin} className="btn btn-primary btn-sm">Login</button>
        )}
      </div>
    </nav>
  );
}

export default NavigationBar;
